import { Group, Title, Text, Card, Stack } from '@mantine/core';
import {
  HomeKnowledgeFileIcon,
  HomeKnowledgeGitbookIcon,
  HomeKnowledgeWebsiteIcon,
  HomeKnowledgeTreeIcon,
  HomeKnowledgeAPIIcon,
  HomeKnowledgeQAIcon,
} from '@/components/icon';
import { AnimateDiv } from '@/components/Common/AnimateDiv';

export const KnowledgeBase = () => {
  const knowledgeTypes = [
    {
      icon: HomeKnowledgeFileIcon,
      title: 'ファイルとドキュメント',
    },
    {
      icon: HomeKnowledgeGitbookIcon,
      title: 'Gitbook',
    },
    {
      icon: HomeKnowledgeWebsiteIcon,
      title: 'ウェブサイト',
    },
    {
      icon: HomeKnowledgeAPIIcon,
      title: 'APIソース',
    },
    {
      icon: HomeKnowledgeTreeIcon,
      title: 'サイトマップ',
    },
    {
      icon: HomeKnowledgeQAIcon,
      title: 'Q&Aデータベース',
    },
  ];

  return (
    <section className="flex flex-col mt-32 max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv>
        <Title order={2} className="text-xl lg:text-5xl font-bold">
          エージェントの頭脳「ナレッジベース」の作成は簡単。
          <br />
          あらゆる情報ソースをAIがナレッジ化
        </Title>
      </AnimateDiv>

      <AnimateDiv>
        <Group align="end" wrap="nowrap" className="mt-4 lg:-mt-12">
          <Text c="dimmed" className="text-sm lg:text-xl lg:pb-12">
            GBase
            Supportは、業界トップクラスの解析精度と多様なフォーマット対応で、製品マニュアルから過去のFAQまであらゆるドキュメントを信頼できるAIナレッジベースへと変換。
            <br />
            AIナレッジエージェントは、特別なセッティングは不要ですぐに利用開始ができます。
          </Text>
          <img src="/home/knowledge.png" alt="" className="w-28 lg:w-60" />
        </Group>
      </AnimateDiv>

      <AnimateDiv>
        <Card withBorder radius="md" className="relative border-[#EBEBEB] p-0 mt-10">
          <img src="/home/knowledge-bg.png" alt="" className="w-full" />
          <div className="absolute top-0 left-0 w-full h-full py-4 lg:py-10 px-4 lg:px-8">
            <Title order={4} className="text-lg lg:text-3xl font-bold">
              幅広いファイル形式に対応
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl lg:w-2/3 lg:mt-2">
              PDF、PPT、スプレッドシート、画像を含むコンテンツもシームレスに取り込み 深い構造理解を実現。
            </Text>
          </div>
          <Stack className="sm:absolute sm:right-0 sm:mt-24 lg:right-40 lg:mt-48 gap-0 sm:gap-6 md:gap-12 lg:gap-20">
            <Group className="scale-75 lg:scale-100 gap-6 sm:justify-center flex-col sm:flex-row">
              {knowledgeTypes
                .filter((_, i) => i === 0 || i === 1)
                .map((item) => (
                  <Group key={item.title} className="rounded-lg bg-[#FFFAF8] px-4 py-2" wrap="nowrap">
                    <item.icon />
                    <Text className="text-xl mt-2">{item.title}</Text>
                  </Group>
                ))}
            </Group>
            <Group className="scale-75 lg:scale-100 lg:-translate-x-28 gap-6 lg:gap-24 sm:justify-center flex-col sm:flex-row">
              {knowledgeTypes
                .filter((_, i) => i === 2 || i === 3)
                .map((item) => (
                  <Group key={item.title} className="rounded-lg bg-[#FFFAF8] px-4 py-2" wrap="nowrap">
                    <item.icon />
                    <Text className="text-xl mt-2">{item.title}</Text>
                  </Group>
                ))}
            </Group>
            <Group className="scale-75 lg:scale-100 gap-6 lg:gap-12 sm:justify-center flex-col sm:flex-row">
              {knowledgeTypes
                .filter((_, i) => i === 4 || i === 5)
                .map((item) => (
                  <Group key={item.title} className="rounded-lg bg-[#FFFAF8] px-4 py-2" wrap="nowrap">
                    <item.icon />
                    <Text className="text-xl mt-2">{item.title}</Text>
                  </Group>
                ))}
            </Group>
          </Stack>
        </Card>
      </AnimateDiv>

      <Group align="stretch" className="mt-10 lg:flex-nowrap">
        <AnimateDiv className="border border-[#EBEBEB] rounded-md !bg-[#F9FAFB] py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Title order={5} className="text-base lg:text-2xl font-bold px-4 lg:px-8">
            スマートFAQ変換
          </Title>
          <Text c="dimmed" className="text-sm lg:text-xl px-4 lg:px-8 mt-2">
            内部ドキュメントから自動的に構造化されたFAQを生成し、柔軟なテンプレートで旧システムからの移行も簡単に。
          </Text>
          <AnimateDiv delay={0.4} className="ml-8 lg:ml-16 mt-8">
            <img src="/home/knowledge1.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
        <AnimateDiv className="border border-[#EBEBEB] rounded-md !bg-[#F9F8FF] py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Title order={5} className="text-base lg:text-2xl font-bold px-4 lg:px-8">
            高精度な回答
          </Title>
          <Text c="dimmed" className="text-sm lg:text-xl px-4 lg:px-8 mt-2">
            高度な技術で正確な回答と高い再現率を実現。自然で役立つユーザーサポートが可能。
          </Text>
          <AnimateDiv delay={0.4} className="ml-8 lg:ml-12 mt-6">
            <img src="/home/knowledge2.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>
    </section>
  );
};
